import { io } from "socket.io-client";
import { BASE_URL } from "./Constants";

const socket = io(`${BASE_URL}/` , {
    transports: ["websocket"],
    withCredentials: true,
    autoConnect: false,
});

export default socket;